import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <p style={styles.text}>
        © 2025 New-NightLife All rights reserved.
      </p>

      <Link to="/login" style={styles.loginLink} aria-label="管理者ログイン">
        <FaChevronRight style={styles.icon} />
      </Link>
    </footer>
  );
};

const styles = {
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    backgroundColor: '#333',
    color: '#fff',
    marginTop: '20px',
    flexWrap: 'wrap',
  },
  text: {
    fontSize: '12px',
    color: '#aaa',
    margin: 0,
  },
  loginLink: {
    color: '#e91e63',
    textDecoration: 'none',
    padding: '8px',
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
  },
  icon: {
    fontSize: '18px',
    transition: 'transform 0.3s ease',
  },
};

export default Footer;
